import { Component, Input } from '@angular/core';

import { IconSizeEnum } from '../../_enums/icon.enum';
import { PositionEnum } from '../../_enums/position.enum';
import { IIconLabel } from '../../_interfaces/header.interface';

import { SdTooltipComponent } from '../tooltips/tooltip/tooltip.component';
import { SdIconComponent } from '../icons/icon/icon.component';
import { SdLinkComponent } from '../links/link/link.component';
import { SdListComponent } from '../lists/list/list.component';
import { SdHtmlComponent } from '../html/html.component';

@Component({
  selector: 'sd-header-reinsurances',
  templateUrl: './header-reinsurances.component.html',
  standalone: true,
  imports: [
    SdListComponent,
    SdTooltipComponent,
    SdLinkComponent,
    SdIconComponent,
    SdHtmlComponent
  ]
})
export class SdHeaderReinsurancesComponent {
  iconSizeEnum = IconSizeEnum;
  positionEnum = PositionEnum;

  @Input()
  reinsurancesData: IIconLabel[];
}
